import React from 'react'
import styles from './Offers.module.scss'



const Offers = () => {
    return (
        <ul className={styles.list}>
            <li className={styles.item}>
                <p className={styles.check}>&#10003;</p>
                <p className={styles.item_text}><span>Доступные цены</span></p>
            </li>
            <li className={styles.item}>
                <p className={styles.check}>&#10003;</p>
                <p className={styles.item_text}><span>Кратчайшие сроки</span></p>
            </li>
        </ul>
    )
}

export default Offers